import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useSearchParams } from "react-router-dom";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import CaseListV2 from "./caseListV2";
import { useDispatch } from "react-redux";
import { setOutsideUser } from "../../redux/roleSlice";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CaseServices } from "../../services/CaseServices";
import { InterUserMangementServices } from "../../services/InternalUserMangementServices";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import "./manageCases.scss";
import { CircularProgress } from "@mui/material";
import { updatePageNumber } from "../../redux/caseDetailsSlice";
import RefreshIcon from "../../assets/caseMappingIcon.svg";
import { RpaServices } from "../../services/RpaServices";
import { HospitalServices } from "../../services/HospitalServices";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { toast } from "react-toastify";
const ActiveCasesDashboardV2 = () => {
  const [caseStatus, setCaseStatus] = useState("");
  const [stageColor, setStageColor] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [caseStageReport, setCaseStageReport] = useState(null);
  const [selectedStage, setSelectedStage] = useState(null);
  const [getDataCheck, setDataCheck] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [openAccordion, setAccordion] = useState(null);
  const [assignedUserStages, setAssignedUserStages] = useState(null);
  const [assignedFilter, setAssignedFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [pending, setPending] = useState(false);
  const storeCaseId = useSelector((state) => state.caseDetails.caseId);
  const selectedStageRef = useRef();
  const lastCalledRef = useRef(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const id = searchParams.get("caseId");
  const token = searchParams.get("token");
  if (token) {
    dispatch(setOutsideUser(true));
    const userDetails = JSON.stringify({
      session: {
        token: atob(decodeURIComponent(token)),
        updatedAt: "2024-09-12T11:40:46.539Z",
        createdAt: "2024-09-12T11:40:46.539Z",
      },
      hospital: {},
    });
    localStorage.setItem("userDetails", userDetails);
  }

  const getPendingTime = (caseDate) => {
    let date1 = new Date(caseDate); // oldest case's date in this stage
    let date2 = new Date(); // current date

    // Calculate the difference in milliseconds
    let differenceInMilliseconds = date2 - date1;

    // Calculate the difference in days, hours, minutes, and seconds
    let days = Math.floor(differenceInMilliseconds / (1000 * 3600 * 24));
    let hours = Math.floor(
      (differenceInMilliseconds % (1000 * 3600 * 24)) / (1000 * 3600),
    );
    let minutes = Math.floor(
      (differenceInMilliseconds % (1000 * 3600)) / (1000 * 60),
    );
    let seconds = Math.floor((differenceInMilliseconds % (1000 * 60)) / 1000);
    return `${days}D ${hours}H ${minutes}M ${
      !days && !hours && !minutes ? seconds + "S" : ""
    }`;
  };
  const getStageColor = (stageStatus, oldestCaseTime, bgColor) => {
    let date1 = oldestCaseTime ? new Date(oldestCaseTime) : new Date(); // oldest case's date in this stage
    let date2 = new Date(); // current date

    // Calculate the difference in milliseconds
    let differenceInMilliseconds = date2 - date1;
    // let minutes = Math.floor(differenceInMilliseconds / (1000 * 60));
    const filteredData = stageStatus?.filter(
      (stage) =>
        stage.endTime === "" ||
        stage.endTime === null ||
        (differenceInMilliseconds >= Number(stage.startTime) * 60 * 1000 &&
          differenceInMilliseconds <= Number(stage.endTime) * 60 * 1000),
    );
    if (bgColor) {
      return filteredData?.length > 0 ? filteredData[0]?.bgColor : "#FFFFFF";
    }

    return filteredData?.length > 0
      ? filteredData[0]?.bgColor?.includes("#D32F2F")
        ? "#FFFFFF"
        : filteredData[0]?.textColor
      : "#000000";
  };
  const getStageCaseReport = async () => {
    setLoading(true);
    try {
      const response = await CaseServices.stageCaseReport(assignedUserStages);
      setCaseStageReport(response?.data?.customReport);
      setStageColor(response?.data?.stageStatusTimeColor);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  const getUserAssignedStages = async () => {
    setLoading(true);
    try {
      const response = await InterUserMangementServices.getUserAssignedStages();

      setAssignedUserStages(response.data.assignedCommandCenterStages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleGetAllCasesClick = (AllCases) => {
    if (pending) {
      toast.error("Waiting for previous response");
      return;
    }
    if (getDataCheck) {
      AllCases();
      return;
    }
    setDataCheck(true);
    setSelectedStage({ id: "-1", stages: assignedUserStages });
  };
  const handleCaseStageSelection = (stage) => {
    if (pending) {
      toast.error("Waiting for previous response");
      return;
    }
    setDataCheck(true);
    if (selectedStage?.id === stage?.stageStatusId) {
      setSelectedStage({ id: "-1", stages: assignedUserStages });
    } else {
      let stageArray = [stage.mainStage];
      for (let subStage of stage.subStages) {
        stageArray.push(subStage.stage);
      }
      selectedStageRef.current.scrollIntoView({ behavior: "smooth" });
      dispatch(updatePageNumber(1));
      setSelectedStage({ id: stage.stageStatusId, stages: stageArray });
    }
  };

  const handleAddNewCase = () => {
    navigate("/addcases");
  };

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    getUserAssignedStages();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  useEffect(() => {
    if (assignedUserStages) {
      const now = Date.now();
      const FIVE_MINUTES = 5 * 60 * 1000;

      if (now - lastCalledRef.current >= FIVE_MINUTES) {
        getStageCaseReport();
        setSelectedStage({ id: "-1", stages: assignedUserStages });
        lastCalledRef.current = now;
      }
    }
  }, [assignedUserStages, storeCaseId]);

  // console.log("assigned stages:", assignedUserStages);

  return (
    <div className="manage-box">
      <div className="flex items-center space-x-9">
        <span className="path_line flex items-center space-x-2">
          <WidgetsOutlinedIcon style={{ height: "24px" }} />
          <span>/Dashboard</span>
          <span className="whitespace-nowrap">/ Manage Cases</span>
        </span>
        <div className="w-full z-20 p-4 flex flex-col items-start ml-7"></div>
      </div>
      <div className="flex justify-end mb-3">
        <div
          className="flex items-center justify-center gap-3  px-5 2xl:px-8 py-3  rounded-full border-2 border-[#d5d5d5] border-solid bg-[#f5f5f5] cursor-pointer"
          onClick={() => {
            !loading && getStageCaseReport();
          }}
        >
          {loading ? (
            <>
              {" "}
              <CircularProgress size={20} /> Refreshing ...
            </>
          ) : (
            <>
              <img src={RefreshIcon} alt="refresh-icon" />
              Refresh Card Details
            </>
          )}
        </div>
      </div>
      {loading ? (
        <div className="flex justify-center items-center h-[70vh]">
          <CircularProgress />
        </div>
      ) : (
        <div>
          {" "}
          {caseStageReport?.filter(
            (stage) =>
              stage?.mainStage?.toLowerCase().includes("admission") ||
              stage?.mainStage?.toLowerCase().includes("reference") ||
              stage?.stageText?.toLowerCase().includes("admission"),
          ).length > 0 && (
            <Accordion
              expanded={openAccordion === 1}
              style={{ marginBottom: "4px", borderRadius: "12px" }}
            >
              <AccordionDetails>
                <div className="flex gap-4 items-start">
                  <div className="w-[140px] text-xl text-[#191919] font-semibold">
                    Admission
                  </div>
                  {caseStageReport ? (
                    <div className="w-[90%] grid xl:grid-cols-5 2xl:grid-cols-6 gap-3">
                      {caseStageReport
                        ?.filter(
                          (stage) =>
                            stage?.mainStage
                              ?.toLowerCase()
                              ?.includes("admission") ||
                            stage?.mainStage
                              ?.toLowerCase()
                              ?.includes("reference") ||
                            stage?.stageText
                              ?.toLowerCase()
                              ?.includes("admission"),
                        )
                        .map((stage, idx) => {
                          return (
                            <div
                              key={idx}
                              style={{
                                backgroundColor: getStageColor(
                                  stageColor[stage.stageStatusId],
                                  stage.oldestCaseDate,
                                  true,
                                ),

                                border:
                                  selectedStage?.id === stage?.stageStatusId &&
                                  "2px solid #999999",
                                boxShadow:
                                  selectedStage?.id === stage?.stageStatusId &&
                                  "0 1px 20px rgba(0, 0, 0, 0.7)",
                                transform:
                                  selectedStage?.id === stage?.stageStatusId &&
                                  "scale(1.1, 1.2)",
                              }}
                              className={`flex flex-col justify-between h-[90px] py-2 px-[5] rounded-[8px] cursor-pointer hovernow`}
                              onClick={() => handleCaseStageSelection(stage)}
                            >
                              <div
                                style={{
                                  color: getStageColor(
                                    stageColor[stage.stageStatusId],
                                    stage.oldestCaseDate,
                                    false,
                                  )?.slice(0, 7),
                                }}
                                className="text-xs text-[#191919] font-semibold text-center"
                              >
                                {stage.mainStageFullName || stage.mainStage}
                              </div>
                              <div
                                style={{
                                  color: getStageColor(
                                    stageColor[stage.stageStatusId],
                                    stage.oldestCaseDate,
                                    false,
                                  )?.slice(0, 7),
                                }}
                                className="text-sm text-center font-semibold"
                              >
                                {stage.totalNewCases || "0"}/
                                {stage.totalCaseCount}
                              </div>
                              <div
                                style={{
                                  backgroundColor:
                                    getStageColor(
                                      stageColor[stage.stageStatusId],
                                      stage.oldestCaseDate,
                                      false,
                                    )?.slice(0, 7) + "15",
                                  color: getStageColor(
                                    stageColor[stage.stageStatusId],
                                    stage.oldestCaseDate,
                                    false,
                                  )?.slice(0, 7),
                                }}
                                className="bg-white text-xs text-[#191919] font-semibold text-center py-[2px]"
                              >
                                From:{" "}
                                <span>
                                  {stage?.oldestCaseDate
                                    ? getPendingTime(stage.oldestCaseDate)
                                    : "---"}
                                </span>
                              </div>{" "}
                            </div>
                          );
                        })}
                    </div>
                  ) : (
                    <div className="w-[90%] flex justify-center">
                      {" "}
                      <CircularProgress />
                    </div>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          )}
          {caseStageReport?.filter(
            (stage) =>
              stage?.mainStage?.toLowerCase()?.includes("enhancement") ||
              stage?.mainStage?.toLowerCase()?.includes("enhacement"),
          ).length > 0 && (
            <Accordion
              expanded={openAccordion === 2}
              style={{ marginBottom: "4px", borderRadius: "12px" }}
            >
              <AccordionDetails>
                <div className="flex gap-4 items-start ">
                  <div className="w-[140px] text-xl text-[#191919] font-semibold">
                    Enhancement
                  </div>
                  {caseStageReport ? (
                    <div className="w-[90%] grid xl:grid-cols-5 2xl:grid-cols-6 gap-3">
                      {caseStageReport
                        ?.filter(
                          (stage) =>
                            stage?.mainStage
                              ?.toLowerCase()
                              ?.includes("enhancement") ||
                            stage?.mainStage
                              ?.toLowerCase()
                              ?.includes("enhacement"),
                        )
                        .map((stage, idx) => {
                          return (
                            <div
                              key={idx}
                              style={{
                                backgroundColor: getStageColor(
                                  stageColor[stage.stageStatusId],
                                  stage.oldestCaseDate,
                                  true,
                                ),
                                border:
                                  selectedStage?.id === stage?.stageStatusId &&
                                  "2px solid #999999",
                                boxShadow:
                                  selectedStage?.id === stage?.stageStatusId &&
                                  "0 1px 20px rgba(0, 0, 0, 0.7)",
                                transform:
                                  selectedStage?.id === stage?.stageStatusId &&
                                  "scale(1.1, 1.2)",
                              }}
                              className="flex flex-col justify-between h-[90px] py-2 px-[5] rounded-[8px] cursor-pointer hovernow"
                              onClick={() => handleCaseStageSelection(stage)}
                            >
                              <div
                                style={{
                                  color: getStageColor(
                                    stageColor[stage.stageStatusId],
                                    stage.oldestCaseDate,
                                    false,
                                  )?.slice(0, 7),
                                }}
                                className="text-xs text-[#191919] font-semibold text-center"
                              >
                                {stage.mainStageFullName || stage.mainStage}
                              </div>
                              <div
                                style={{
                                  color: getStageColor(
                                    stageColor[stage.stageStatusId],
                                    stage.oldestCaseDate,
                                    false,
                                  )?.slice(0, 7),
                                }}
                                className="text-sm text-center font-semibold"
                              >
                                {stage.totalNewCases || "0"}/
                                {stage.totalCaseCount}{" "}
                              </div>
                              <div
                                style={{
                                  backgroundColor:
                                    getStageColor(
                                      stageColor[stage.stageStatusId],
                                      stage.oldestCaseDate,
                                      false,
                                    )?.slice(0, 7) + "15",

                                  color: getStageColor(
                                    stageColor[stage.stageStatusId],
                                    stage.oldestCaseDate,
                                    false,
                                  )?.slice(0, 7),
                                }}
                                className="bg-white text-xs text-[#191919] font-semibold text-center py-[2px]"
                              >
                                From:{" "}
                                <span>
                                  {stage?.oldestCaseDate
                                    ? getPendingTime(stage.oldestCaseDate)
                                    : "---"}
                                </span>
                              </div>{" "}
                            </div>
                          );
                        })}
                    </div>
                  ) : (
                    <div className="w-[90%] flex justify-center">
                      <CircularProgress />
                    </div>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          )}
          {caseStageReport?.filter(
            (stage) =>
              stage?.mainStage?.toLowerCase()?.includes("discharge") ||
              stage?.mainStage?.toLowerCase()?.includes("claim"),
          ).length > 0 && (
            <Accordion
              expanded={openAccordion === 3}
              style={{ marginBottom: "12px", borderRadius: "12px" }}
            >
              <AccordionDetails>
                <div className="flex gap-4 items-start">
                  <div className="w-[140px] text-xl text-[#191919] font-semibold">
                    Claim
                  </div>
                  {caseStageReport ? (
                    <div className="w-[90%] grid xl:grid-cols-5 2xl:grid-cols-6 gap-3">
                      {caseStageReport
                        // .slice(0, 9)
                        ?.filter(
                          (stage) =>
                            stage?.mainStage
                              ?.toLowerCase()
                              ?.includes("discharge") ||
                            stage?.mainStage?.toLowerCase()?.includes("claim"),
                        )
                        .map((stage, idx) => {
                          return (
                            <div
                              key={idx}
                              style={{
                                backgroundColor: getStageColor(
                                  stageColor[stage.stageStatusId],
                                  stage.oldestCaseDate,
                                  true,
                                ),
                                border:
                                  selectedStage?.id === stage?.stageStatusId &&
                                  "2px solid #999999",
                                boxShadow:
                                  selectedStage?.id === stage?.stageStatusId &&
                                  "0 1px 20px rgba(0, 0, 0, 0.7)",
                                transform:
                                  selectedStage?.id === stage?.stageStatusId &&
                                  "scale(1.1, 1.2)",
                              }}
                              className="flex flex-col justify-between h-[90px] py-2 px-[5] rounded-[8px] cursor-pointer hovernow"
                              onClick={() => handleCaseStageSelection(stage)}
                            >
                              <div
                                style={{
                                  color: getStageColor(
                                    stageColor[stage.stageStatusId],
                                    stage.oldestCaseDate,
                                    false,
                                  )?.slice(0, 7),
                                }}
                                className="text-xs text-[#191919] font-semibold text-center"
                              >
                                {stage.mainStageFullName || stage.mainStage}
                              </div>
                              <div
                                style={{
                                  color: getStageColor(
                                    stageColor[stage.stageStatusId],
                                    stage.oldestCaseDate,
                                    false,
                                  )?.slice(0, 7),
                                }}
                                className="text-sm text-center font-semibold"
                              >
                                {stage.totalNewCases || "0"}/
                                {stage.totalCaseCount}{" "}
                              </div>
                              <div
                                style={{
                                  backgroundColor:
                                    getStageColor(
                                      stageColor[stage.stageStatusId],
                                      stage.oldestCaseDate,
                                      false,
                                    )?.slice(0, 7) + 15,

                                  color: getStageColor(
                                    stageColor[stage.stageStatusId],
                                    stage.oldestCaseDate,
                                    false,
                                  )?.slice(0, 7),
                                }}
                                className="text-xs text-[#191919] font-semibold text-center py-[2px]"
                              >
                                From:{" "}
                                <span>
                                  {stage?.oldestCaseDate
                                    ? getPendingTime(stage.oldestCaseDate)
                                    : "---"}
                                </span>
                              </div>{" "}
                            </div>
                          );
                        })}
                    </div>
                  ) : (
                    <div className="w-[90%] flex justify-center">
                      <CircularProgress />
                    </div>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          )}
        </div>
      )}

      <hr
        style={{
          color: "#E7E7E7",
          marginBlock: "32px",
        }}
      />
      <div
        style={{
          display: width > 640 ? "flex" : "block",
          marginBlock: "8px",
        }}
        className="heading"
      >
        <div>
          Manage Cases{" "}
          <span ref={selectedStageRef} className="text-[16px]">
            :
            {` ${
              (selectedStage &&
                selectedStage.stages &&
                selectedStage?.stages[0]) ||
              ""
            }`}
          </span>
        </div>

        <div className="btn-container">
          {" "}
          {getDataCheck && (
            <div className="text-base font-normal">
              <Select
                name="assignedCases"
                isClearable
                options={[
                  { value: "assigned", label: "Assigned" },
                  { value: "unassigned", label: "Not Assigned" },
                ]}
                getOptionLabel={(options) => {
                  return options["label"];
                }}
                getOptionValue={(options) => {
                  return options["value"];
                }}
                onChange={(item) => {
                  // setPage(1);
                  item ? setAssignedFilter(item.value) : setAssignedFilter("");
                }}
                value={[
                  { value: "assigned", label: "Assigned" },
                  { value: "unassigned", label: "Not Assigned" },
                ].filter((option) => option.value === assignedFilter)}
                placeholder="Assigned Filter"
              />
            </div>
          )}
          <button
            style={{ cursor: "pointer" }}
            className="filled-btn"
            onClick={handleAddNewCase}
          >
            + ADD CASE
          </button>
          {/* <button
            className="filled-btn"
            onClick={() => navigate("/dashboard/dut-work-space")}
          >
            START DUT
          </button> */}
        </div>
      </div>

      <>
        {id ? (
          <CaseListV2
            caseId={atob(decodeURIComponent(id))}
            selectedStage={selectedStage?.stages}
            getStageCaseReport={getStageCaseReport}
            getStageColor={getStageColor}
            assignedFilter={assignedFilter}
            handleGetAllCasesClick={handleGetAllCasesClick}
            getDataCheck={getDataCheck}
            setDataCheck={setDataCheck}
            setPending={setPending}
            setSelectedStage={setSelectedStage}
            assignedUserStages={assignedUserStages}
          />
        ) : (
          <CaseListV2
            selectedStage={selectedStage?.stages}
            getStageCaseReport={getStageCaseReport}
            getStageColor={getStageColor}
            assignedFilter={assignedFilter}
            handleGetAllCasesClick={handleGetAllCasesClick}
            getDataCheck={getDataCheck}
            setDataCheck={setDataCheck}
            setPending={setPending}
            setSelectedStage={setSelectedStage}
            assignedUserStages={assignedUserStages}
          />
        )}
      </>
    </div>
  );
};

export default ActiveCasesDashboardV2;
